package kz.dentalcrm.app.screens.splash

import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.launch
import kz.dentalcrm.app.core.base.BaseStateViewModel
import kz.dentalcrm.app.domain.AuthRepository
import kz.dentalcrm.app.screens.splash.mvi.SplashViewEvent
import kz.dentalcrm.app.screens.splash.mvi.SplashViewSideEffect
import kz.dentalcrm.app.screens.splash.mvi.SplashViewState
import org.koin.core.component.inject

class SplashViewModel : BaseStateViewModel<SplashViewEvent, SplashViewState, SplashViewSideEffect>() {

    private val authRepository: AuthRepository by inject()

    override fun setInitialState() = SplashViewState()

    init {
        setEvent(SplashViewEvent.CheckAuth)
    }

    override fun handleEvents(event: SplashViewEvent) {
        when (event) {
            SplashViewEvent.CheckAuth -> checkAuth()
        }
    }

    private fun checkAuth() {
        launch(Dispatchers.Default) {
            val isLoggedIn = authRepository.isLoggedIn()
            setEffect {
                if (isLoggedIn) SplashViewSideEffect.NavigateToMain
                else SplashViewSideEffect.NavigateToLogin
            }
        }
    }
}
